<template>
  <div class="main" id="Sizes">
    <Header :From="'Profile'" id="Header"/>
    <CContainer class="d-flex content-center min-vh-90" id="container">
      <div class="row p-0 m-0">
        <div class="col-lg-4 col-md-4 col-sm-12"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 p-0 m-0 box account-box">
          <div class="title">
            <img src="/icons_2/prev.png" alt="" @click="$router.go(-1)" />
            <span> {{$t("Sizes.MySizes")}} </span>
            <!-- <img src="/icons/tick.png" alt="" @click="$router.go(-1)" style="float: right;margin-top: 0px;"/> -->
          </div>

          <div class="addresses">
            <div class="load" v-if="loading">
              <CIcon name="cil-cart" height="48" />
            </div>

            <div
              class="address"
              v-for="userSize in user_sizes"
              :key="userSize.id"
              v-if="user_sizes.length>0"
            >
                <div class="addresses-top size-div">
                    <span class="item-title">{{userSize.type.name}}:</span>
                    <button
                    class="button delete-address"
                    >
                      {{(userSize.size)?userSize.size.name:'--'}}
                    </button>
                    <select class="size-select">
                        <option v-if="userSize.size" :value="userSize.type.id+','+userSize.size.id" selected>{{userSize.size.name}}</option>
                        <option :value="userSize.type.id+',0'">{{$t("Sizes.DisplayAll")}}</option>
                        <option 
                          v-for="item in userSize.type.sizes" 
                          :key="item.id"
                          :value="userSize.type.id+','+item.id" 
                        >
                          {{item.name}}
                        </option>
                    </select>
                </div>
            </div>

            <div
              class="address"
              v-for="userSize in unsetSizes"
              :key="'unset-'+userSize.id"
              v-if="unsetSizes.length>0"
            >
                <div class="addresses-top size-div">
                    <span class="item-title">{{userSize.name}}:</span>
                    <button
                    class="button delete-address"
                    >
                      --
                    </button>
                    <select class="size-select">
                        <option :value="userSize.id+',0'">{{$t("Sizes.DisplayAll")}}</option>
                        <option 
                          v-for="item in userSize.sizes" 
                          :key="item.id"
                          :value="userSize.id+','+item.id" 
                        >
                          {{item.name}}
                        </option>
                    </select>
                </div>
            </div>

            <CRow style="margin-top: 10px;" @click="submitSizes()">
                    <CCol col="12" class="text-left">
                        <CButton type="submit" color="primary" class="px-4 w-100" style=" background: #ef86c1; border-color: #ef86c1; ">
                            <font-awesome-icon class="faIcon" icon="cogs" />
                            {{$t("Sizes.Update")}}
                        </CButton>
                    </CCol>
            </CRow>
          </div>
        </div>
      </div>
    <vue-confirm-dialog></vue-confirm-dialog>
    </CContainer>
  </div>
</template>

<script>
import { userService, typeService } from "../../../_services";
import Header from '../../../components/Header.vue';
import $ from 'jquery'

export default {
  name: "Swiper",
  components: {
    Header
  },
  data: () => ({
    loading: false,
    user: {
      name: "",
      phone: "",
      email: "",
    },
    user_sizes: [],
    offset: 0,
    collapsePrefences: true,
    collapseAccount: false,
    sizes: [],
    unsetSizes: []
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("shop_user"));
  },
  methods: {
    submitSizes(){
        let loader= this.$loading.show();
        let data= []
        $('.size-select').each(function (i) {
            data.push( $(this).val() )
        })

        userService.updateSizes({'data': data}).then(function(data){
            console.log(data);
            this.$router.go(-1)
        }.bind(this)).finally(function(){
            loader.hide()
        }.bind(this))
    }
  },

  mounted() {
    let loader= this.$loading.show();

    userService.getSizes().then(function(data){
        console.log(data);
        this.user_sizes= data.sizes;
    }.bind(this))

    //GET UNSET SIZES
    userService.getUnsetSizes().then(function(data){
            console.log(data);
            this.unsetSizes = data.unset_sizes
        }.bind(this)).finally(function(){
            loader.hide()
        }.bind(this))
  },
};
</script>
<style lang="scss" scoped>
#Sizes{
  .account-box {
    background: #fff;
  }
  .box {
    background: #fff;
    width: 100%;
    width: 50vw;
    margin-top: 70px !important;
    margin-left: 15px !important;
    box-shadow: 0 0 8px 1px #ddd;
    margin-bottom: 30px !important;
  }

  .title {
    letter-spacing: 2px;
    font-size: 20px;
    padding: 10px;
    border-bottom: 2px solid #ddd;
    color: #666;
  }
  .title img {
    float: left;
    width: 30px;
    margin-top: 5px;
  }
  .addresses {
    text-align: left;
    background: #eee;
    padding: 10px;
  }
  .subtitle {
    font-size: 15px;
    letter-spacing: 1px;
    font-weight: bold;
    display: block;
    padding: 0 0 0 10px;
    text-transform: uppercase;
    transition: 0.3s;
  }
  .address {
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    margin-bottom: 10px;
  }
  .addresses-top {
      position: relative;
      margin-top: -10px;
  }
  .addresses-top span {
    display: inline-block;
  }
  .addresses-top button {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-top: -5px;
    color: #fff;
    border: none;
    border-radius: 0 10px 0 5px;
    position: absolute;
    right: -20px;
    top: -5px;
    outline: none;
  }
  .input-div{
      padding: 0 10px;
  }
  .input-div div{
      margin-top: 5px;
  }
  .input-div label{
      display: block;
  }
  .input-div input{
      display: block;
      width: 100%;
      border: 1px solid #eee;
      height: 30px;
      padding: 0 10px;
      border-radius: 5px;
  }
  .size-div select{
      width: 100%;
      display: block;
      margin-top: 10px;
      height: 30px;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 0 5px;
  }
  @media screen and (max-width: 720px) {
    .box {
      width: 100vw;
      max-width: 100vw;
      position: absolute;
      transform: translate(-50%);
      margin-top: 0px !important;
      box-shadow: 0 0 0 0 #ddd;
    }
    #Header{
        display: none;
      }
      .title{
        color: #ef86c1 !important;
      }
      .title img{
        display: inline-block;
      }
  }
}
</style>
